<div class="modal__header">
    <div class="modal__header-actions header-actions--mobile">
        <button aria-label="Close dialog" (click)="INDRA_close()">
            <app-svg
                svg="icons.svg#general--arrow--left-no_margin"
                aria-hidden="true"
                [alt]="'Arrow left icon'"
            >
            </app-svg>
        </button>
    </div>
    <div class="title_wrapper">
        <h4 id="modal__title">{{ 'ancillaries.bundlesModal.title' | ibeadmin | async }}</h4>
    </div>
    <div class="modal__header-actions header-actions">
        <button aria-label="Close dialog" (click)="INDRA_close()">
            <app-svg
                svg="icons.svg#general--not_available"
                aria-hidden="true"
                [alt]="'Close icon'"
            >
            </app-svg>
        </button>
    </div>
</div>

<div class="modal__body select-themes-body sl--scrollable">
    <span class="sub-title bottom-gap display--block">
        {{ 'ancillaries.bundlesModal.subTitle' | ibeadmin | async }}
    </span>

    <section id="modal-bundles-cards" *ngIf="this.available_bundles">
        <ng-container *ngFor="let pack of this.available_bundles">
            <app-bundle-card
                [pack]="INDRA_getPackSegments(pack)"
                [bound]="this._flight"
                [style.background-image]="INDRA_printImage()"
                [disable]="false"
                [fromModal]="true"
                (add)="INDRA_handleOpenPack(pack)"
                [ngClass]="INDRA_getCardStyles()">
            </app-bundle-card>
        </ng-container>
    </section>

    <div class="form-field--row grid no-padding modal__actions">
        <button class="button button-main-line top-gap col-12 col-tp-12 col-p-12" (click)="INDRA_handleOpenExtra(this.extra)">
            {{ 'ancillaries.bundlesModal.continueWithoutBundle' | ibeadmin | async }}
        </button>
    </div>
</div>